/**
 * Config method for main CMS module. We'll start configuration using providers.
 *
 * @function appConfig
 * @memberOf cms.MainModule
 */
/** @ngInject */
export default function appConfig(baSidebarServiceProvider, baConfigProvider, layoutPaths, gettext, $locationProvider, localStorageServiceProvider, $animateProvider, $httpProvider) {

    $locationProvider.html5Mode(true);

    $httpProvider.interceptors.push('XdebugInterceptor');
    $httpProvider.interceptors.push('LoaderInterceptor');
    $httpProvider.interceptors.push('ResponseInterceptor');

    localStorageServiceProvider.setStorageType('localStorage');
    localStorageServiceProvider.setPrefix('cms');
    $animateProvider.customFilter(function(node, event, options) {
        if(!!node.attributes.toast)
            return true;

        return /\banimated\b|ui-select-/.test(node.className);
    });

    const IMAGES_ROOT = '/images/blur_admin/';
    layoutPaths.images.root = IMAGES_ROOT;
    layoutPaths.images.profile = IMAGES_ROOT + 'app/profile/';
    //baConfigProvider.changeTheme({blur: true});
}


// WEBPACK FOOTER //
// ./src/mainModule/js/cmsConfig.js